import { Component, OnInit, ViewChild } from "@angular/core";
import { DataShareService } from "../../shared/services/data.service";
import { MessageService } from "../../shared/services/message.service";
import { ViewTabModel } from "../interface/ticketingsystem/view-tab-model";
import { DeleteModal } from "../models/delete-modal";
import { Constants } from "../common/constants";
import { CommonMessage } from "../common/common-messages";
import { MyTicketsComponent } from "./my-tickets.component";
import { MyTeamTicketsComponent } from "./my-team-tickets.component";
@Component({
    selector: "dispute-tickets",
    templateUrl: "../templates/template1/views/dispute-tickets.component.html",
    styleUrls: [
        "../templates/template1/themes/default/css/ticket.less"
    ]
})
export class DisputeTicketsComponent implements OnInit {
    @ViewChild(MyTicketsComponent) myTicketsComponent :  MyTicketsComponent;
    @ViewChild(MyTeamTicketsComponent) myTeamTicketsComponent :  MyTeamTicketsComponent;
    rightContentWidth: number = 1000;
    active:boolean = true;
    id: any;
    tabTitle: string;
    componentName: any;
    ticketId : any;
    isView:boolean;
    ticketCategory:number;
    tabModel: ViewTabModel;
    tabs: any[] = new Array<ViewTabModel>();
    existedValues: ViewTabModel[] = new Array<ViewTabModel>();
    deleteModal: DeleteModal;
    justifyingTabs = false;
    constructor(private _dataShareService: DataShareService,
        private messageService: MessageService) {

    }
    ngOnInit(): void {
        this.tabModel = new ViewTabModel();
        this.subscribeTabContent();
        this.subscribeClosedTabs();
        this.active=false;
        
        this.activetab = 1;
        this._dataShareService.customerServiceMessage.subscribe(message => {
            if (message && message !== '') {
                var splittedMessage = message.split('-');
                this.rightContentWidth = parseInt(splittedMessage[0])   ;
               
            }
        });
    };
    activetab: number;
    selectTab(tab: any) {
        this.activetab = tab;
        if(tab == 1){
            this.myTicketsComponent.onSearch();
        }else if(tab == 2){
            this.myTeamTicketsComponent.onSearch()
        }
    }
    changeTab(tab: any) {
        this.activetab = tab;
    }
    /**
      * To get Tabs information (AS of now-- true / false) -- True refers there are opened tabs
  */
  subscribeClosedTabs() {
    this.messageService.getCloseTabsEvent().subscribe((data: any) => {
        if (data) {
        
        }
    });
}

    subscribeTabContent() {
        this.messageService.getCustomerServiceTabContent().subscribe((data: any) => {
            if (data) {
                this.id = data.id;
                this.tabTitle = data.tabName;
                this.componentName = data.componentName;
                this.ticketId = data.ticketId;
                this.isView = data.isView;
                this.ticketCategory = data.ticketCategory;
                this.addNewTab();
                this.justifyingTabs = (this.tabs && this.tabs.length) ? true : false;
                // observable event to display close all open tabs link in ui in search screen (For SearchComponent)
                this.messageService.setOpenTabsInfo((this.tabs && this.tabs.length) ? true : false);
            }
        });
    }

    addNewTab(): void {
        const newTabIndex = this.tabs.length + 1;
        this.tabModel = new ViewTabModel();

        this.tabModel.id = this.id;
        this.tabModel.title = this.tabTitle;
        this.tabModel.disabled = false;
        this.tabModel.removable = true;
        this.tabModel.active = true;
        this.tabModel.ticketId = this.ticketId;
        this.tabModel.isView = this.isView;
        this.tabModel.tabIndex= newTabIndex+2;
        this.tabModel.ticketCategory = this.ticketCategory;
        this.tabModel.componentName = this.componentName;
        this.activetab = newTabIndex  +2;
        this.existedValues = new Array<ViewTabModel>()
        var index = this.tabs.map(function (el) {
            return el.id;
        }).indexOf(this.id);
        if (this.tabs.length === Constants.MaximumTabsLength) {
            // need to display information -- as you reached maxiumum number of tabs.
            //this.tabs.splice(0, 1);
            this.displayAlertBoxOnReachingMaxTabs();
        }
        else {
            if (index < 0) {
                this.tabs.push(this.tabModel);
            }
            else {
                let selectedId = this.id;
                this.tabs.forEach(function (x: ViewTabModel) {
                    if (x.id !== selectedId) {
                        x.active = false
                    }
                    else {
                        x.active = true;
                    }
                });
            }
        }
    }

     /**
     * display alert box on reaching maximum no of tabs = 8
     */
    displayAlertBoxOnReachingMaxTabs() {
        this.deleteModal.toggle = true;
        this.deleteModal.message = CommonMessage.tabsMessage;
    }
    /*
    remove tabs method
     */
    removeTabHandler(tab: any): void {
        if (this.tabs) {
            
            this.tabs.splice(this.tabs.indexOf(tab), 1);
            this.justifyingTabs = (this.tabs && this.tabs.length) ? true : false;
            this._dataShareService.changeCloseAllTabsMessage((this.justifyingTabs ? 1 : 0) + "- tabs");
                this.activetab = tab.ticketCategory;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/customerservice/components/dispute-tickets.component.ts